import React, { useState, useEffect} from "react";
import "./Timeline.scss";
import { timelineData } from "./TimelineData";
import Lines from "../../../components/Lines";
import TimeLineCard from "./TimeLineCard/TimeLineCard";
import Carousel from "../../../Academics/Programmes Dynamic Page/Carousel";
import "./TimeLineCarousel.scss";
import { MdKeyboardDoubleArrowRight } from "react-icons/md";
import { MdKeyboardDoubleArrowLeft } from "react-icons/md";
import TimeLineImg1 from "../../../assets/TimeLine/2022.png";
import TimeLineImg2 from "../../../assets/TimeLine/2017-2022.png";
import TimeLineImg3 from "../../../assets/TimeLine/2011-2016.png";
import TimeLineImg4 from "../../../assets/TimeLine/2005-2010.png";
import TimeLineImg5 from "../../../assets/TimeLine/2001-2004.png";



const Timeline = () => {

    const imageMap = {
        "image1.jpg": TimeLineImg1,
        "image2.jpg": TimeLineImg2,
        "image3.jpg": TimeLineImg3,
        "image4.jpg": TimeLineImg4,
        "image5.jpg": TimeLineImg5,

    };

    const [currentSlide, setCurrentSlide] = useState(0);

    useEffect(() => {
        const timer = setTimeout(() => {
          setCurrentSlide(1);
        }, 50); 
        return () => clearTimeout(timer);
      }, []);

    const handleNext = () => {
        setCurrentSlide((prev) => Math.min(prev + 1, timelineData.length - 1));
    };
    const handlePrev = () => {
        setCurrentSlide((prev) => Math.max(prev - 1, 0));
    };
    const CustomNextArrow = ({ currentSlide, handleNext, maxSlide, onClick }) => {
        if(currentSlide >= maxSlide) return null;

        return (
            <div
                className="customArrows customNextArrow"
                onClick={() => {
                        handleNext();
                        if (onClick) onClick();
                    }
                }
            >
                <MdKeyboardDoubleArrowRight className="right-arrow" />
            </div>
        );
    };

    const CustomPrevArrow = ({ currentSlide, handleNext, maxSlide, onClick }) => {
        if (currentSlide === 0) return null;
        return (
            <div className="customArrows customPrevArrow" onClick={() => {
                handlePrev();
                if (onClick) onClick();
            }}>
                <MdKeyboardDoubleArrowLeft className="left-arrow" />
            </div>
        );
    };

    return (
        <>
            <div className="timeline-component">
                {timelineData.map((entry, index) => (
                    <React.Fragment key={index}>
                        {index > 0 && (
                            <div className={`lines-container ${index % 2 === 0 ? "left-side" : "right-side"}`}>
                                <Lines count={25} color="white" skewParent={-40} spacing={0.1} thickness={700} />
                            </div>
                        )}
                        <div className="timeline-entry">
                            {index % 2 === 0 ? (
                                <>
                                    <div className="entry-image" >
                                        <img src={imageMap[entry.imageUrl]} alt={`Event ${entry.year}`} />
                                    </div>
                                    <div className="middleLineParent">
                                        <div className={`middleLine turn-right`}></div>
                                    </div>
                                    <div className="entry-content">
                                        <h2 className="year">{entry.year}</h2>
                                        <p className="description">{entry.description}</p>
                                    </div>
                                </>
                            ) : (
                                <>
                                    <div className="entry-content">
                                        <h2 className="year" style={{ color: "white" }}>{entry.year}</h2>
                                        <p className="description" style={{ color: "white" }}>{entry.description}</p>
                                    </div>
                                    <div className="middleLineParent">
                                        <div className={`middleLine turn-left`}></div>
                                    </div>
                                    <div className="entry-image" style={{ marginBottom: "15px" }}>
                                        <img src={imageMap[entry.imageUrl]} alt={`Event ${entry.year}`} />
                                    </div>
                                </>
                            )}
                        </div>
                    </React.Fragment>
                ))}
            </div>
            <section className="timeline-carousel" style={{ overflow: "hidden" }}>
                <Carousel
                    data={timelineData}
                    CardComponent={(props) => <TimeLineCard {...props} imageMap={imageMap} />}
                    slidesToShow={1}
                    arrows={true}
                    color1="#FFFFFF"
                    color2="#3B9D78"
                    dots={true}
                    upto975={1}
                    defaultArrows={false}
                    currentSlide = {currentSlide}
                    setCurrentSlide = {setCurrentSlide}
                    customNextArrow={<CustomNextArrow 
                        currentSlide={currentSlide}
                        handleNext={handleNext}
                        maxSlide={4}
                    />}
                    customPrevArrow={<CustomPrevArrow 
                        currentSlide={currentSlide}
                        handlePrev={handlePrev}
                        />}
                
                />
            </section>
        </>
    );
};

export default Timeline;
